import React, { Component } from 'react';
import {
  Col, Row, Input, Button, Form, FormGroup, Label, Alert,
} from 'reactstrap';
import { withApollo } from 'react-apollo';
import { CHECK_COLOR_CODE } from '../../mutation/mutation';

const RETURN_MESSAGES = {
  DOESNT_EXISTS: 'COLOR_CODE_DOESNT_EXISTS',
  USED: 'COLOR_CODE_USED',
  NOT_USED: 'COLOR_CODE_NOT_USED',
};

class CheckColorCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorCode: '',
      validCode: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.checkColorCode = this.checkColorCode.bind(this);
  }

  handleChange(event) {
    this.setState({ colorCode: event.target.value });
  }

  checkColorCode() {
    const { client } = this.props;
    const { colorCode } = this.state;
    client.mutate({
      mutation: CHECK_COLOR_CODE,
      variables: {
        colorCode,
      },
    }).then(({ data }) => {
      const { savCheckColorCode } = data;
      this.setState({
        validCode: savCheckColorCode,
      });
    }).catch(() => {
      // Error
    });
  }

  render() {
    const { colorCode, validCode } = this.state;
    return (
      <div>
        <Form>
          <FormGroup>
            <Label>Check a Color Code</Label>
            <Row>
              <Col>
                <Input
                  type="text"
                  value={colorCode}
                  onChange={this.handleChange}
                  placeholder="Color code"
                />
              </Col>
              <Col>
                <Button
                  color="danger"
                  onClick={this.checkColorCode}
                >
                  Valider
                </Button>
              </Col>
            </Row>
            <br />
            {validCode.message === RETURN_MESSAGES.USED && (
            <Alert color="success">
              {`The color code ${colorCode} is used by the box with the Mac address ${validCode.macAddress}`}
            </Alert>
            )}
            {validCode.message === RETURN_MESSAGES.NOT_USED && (
            <Alert color="warning">
              {`The color code ${colorCode} is not used.`}
            </Alert>
            )}
            {validCode.message === RETURN_MESSAGES.DOESNT_EXISTS && (
            <Alert color="danger">
              {`The color code ${colorCode} doesn't exists.`}
            </Alert>
            )}
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default withApollo(CheckColorCode);



// WEBPACK FOOTER //
// ./src/components/lovebox-info/check-color-code.js